//const server = "http://localhost/projeler/TurkiyeElektronikAPI/index.php/";
//const server = "https://localhost.turkiyeelektronik.com/TurkiyeElektronikAPI/index.php/";
const server = "https://api.turkiyeelektronik.com/index.php/";
export default server;
